import { Box, Button } from "@mui/material";

export interface ToggleOption {
  value: string;
  label: string;
}

interface Props {
  options: ToggleOption[];
  value: string;
  onChange: (value: string) => void;
}

/** Segmented pill toggle — Figma "import" (node 24907:29717): bordered pill,
 *  12×7 button padding inside a 1px border (40px tall), 16px medium labels, green active / white inactive. */
const SegmentedToggle = ({ options, value, onChange }: Props) => (
  <Box
    display="flex"
    // the segments have a floor width, so letting the pill shrink would crop the right one instead of narrowing it
    flexShrink={0}
    border="1px solid var(--gray2)"
    borderRadius="32px"
    overflow="hidden"
  >
    {options.map((opt) => {
      const active = opt.value === value;
      return (
        <Button
          key={opt.value}
          type="button"
          disableElevation
          onClick={() => onChange(opt.value)}
          sx={{
            textTransform: "none",
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "24px",
            // Figma strokes the pill border inside its 40px height (Chart_Card_Headline
            // 7150:17983), so the buttons give up that pixel top and bottom: 1 + 7 + 24 + 7 + 1.
            padding: "7px 12px",
            // every segment takes the widest label in either language (Thai "intensity", 104px), so the pill keeps one width when the language changes
            minWidth: 104,
            border: "none",
            borderRadius: 0,
            color: active ? "var(--white) !important" : "var(--dark)",
            backgroundColor: active
              ? "var(--green) !important"
              : "var(--white)",
            "&:hover": {
              backgroundColor: active ? "var(--green)" : "var(--gray6)",
            },
          }}
        >
          {opt.label}
        </Button>
      );
    })}
  </Box>
);

export default SegmentedToggle;
